/* global envision:false, svDocReady:false */
/**
 * Copyright (C) SiteVision AB 2002-2024, all rights reserved
 *
 */
import '../util/slideShow'; // Used when content list is used in carousel mode

document.querySelectorAll('.sv-contentlist-portlet').forEach((portlet) => {
  const envTabs = portlet.querySelector('.env-tabs');
  const legacyTabs = portlet.querySelector('.sv-tab');

  if (envTabs) {
    envision.tabs(envTabs);
  }

  if (legacyTabs) {
    import(/* webpackChunkName: "tab-plugins" */ './tabPlugins');
  }
});
